import VeeValidate, { Validator } from 'vee-validate';
import validationDictionary from './validationDictionary';

Validator.localize(validationDictionary);

Validator.extend('field-capital-letter', {
  getMessage: field => `El campo ${field} debe tener al menos una letra mayúscula.`,
  validate: value => /(.*[A-Z])/.test(value),
});

Validator.extend('field-lowercase-letter', {
  getMessage: field => `El campo ${field} debe tener al menos una letra minúscula.`,
  validate: value => /(.*[a-z])/.test(value),
});

Validator.extend('field-alphabetic-characters', {
  getMessage: field => `El campo ${field} debe tener al menos seis caracteres alfabéticos.`,
  validate: value => /(.*[a-z]){6}/i.test(value),
});

Validator.extend('field-two-numbers', {
  getMessage: field => `El campo ${field} debe tener al menos dos número.`,
  validate: value => /(.*[0-9]){2}/.test(value),
});

Validator.extend('field-special-chars', {
  getMessage: field => `El campo ${field} debe tener al menos dos caracteres especiales.`,
  validate: value => /(.*[!@#$%^&*()]){2}/.test(value),
});

export default VeeValidate;



// WEBPACK FOOTER //
// ./src/services/veeValidator.js